import { useRef } from 'react';

import RedirectToast from 'Redesign_Funnel/components/RedirectToast';
import useIsMounted from 'Utils/useIsMounted';

export const useRedirectionToast = () => {
  const isMounted = useIsMounted();
  const isToastOpenedRef = useRef(false);
  const onCloseToast = () => {
    if (!isMounted.current) return;
    isToastOpenedRef.current = false;
  };

  const showRedirectMessage = () => {
    if (!isMounted.current) return;
    if (isToastOpenedRef.current) return;

    isToastOpenedRef.current = true;
    RedirectToast({
      message: 'Fuiste redirigido a otro sitio de Kueski',
      onClose: onCloseToast,
    });
  };

  return { showRedirectMessage };
};
